import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PopupComponent } from '../../../../shared/shared-components/modal/popup/popup.component';

@Injectable({
  providedIn: 'root'
})
export class PopupModalService {

  constructor(private matDialog: MatDialog,) { }

  public ModalWarningComponent(message?, type?): any {
    const dialogRef = this.matDialog.open(PopupComponent, {
      width: '70vw',
      height: '60vh',
      backdropClass: 'landingpage-popup',
      panelClass: 'landingpage-popup-inner',
      disableClose: true,
      autoFocus: false,
      data: {message: message, type: type }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (type != 'cancel') {       
      } else if (type == 'cancel') {
      }
    });
  }
}
